export interface ClearVesselMouRequest {
    vesselId: number;
    mou?: VesselMousEnum; 
}

export class ClearVesselMouResponse
{
    clearanceLogs: [];
    isSuccessFull: boolean
}

export enum VesselMousEnum
{
    Paris = 1,
    Riyadh,
    Abuja,
    Caribbean,
    Tokyo,
    Amsa,
    BlackSea
}

export interface VerifyMouDataModel
{
    vesselId: number;
    mouNames:string[];
    subtaskId: number;
    subtaskGuid: string;
    subjectToPsc: boolean;
}